import { useContext } from 'react';
import { ToastMutatorContext } from './toast.context';

export const useToast = () => useContext(ToastMutatorContext);
